// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { slideshowStyles } from "@west/Overrides/Widgets/Basic/Slideshow";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

slideshowStyles.slideshowWrapper = {
    css: css`
        position: relative;
    `,
};

slideshowStyles.prevArrowButton = {
    css: css`
        background: ${color("common.ui6")};
        opacity: 0.66;
        border: 0;
        height: 66px;
        padding: 20px 8px;

        & > ${IconWrapper} {
            color: ${color("common.white")};
            &,
            & > svg {
                height: 26px;
            }
        }
        &:hover {
            background: none;
        }
        &:focus {
            outline: none;
        }
        ${xScreen("lt", "sm")} {
            display: none;
        }
    `,
};
slideshowStyles.nextArrowButton = {
    css: css`
        background: ${color("common.ui6")};
        opacity: 0.66;
        border: 0;
        height: 66px;
        padding: 20px 8px;

        & > ${IconWrapper} {
            color: ${color("common.white")};
            &,
            & > svg {
                height: 26px;
            }
        }
        &:hover {
            background-color: none;
        }
        &:focus {
            outline: none;
        }
        ${xScreen("lt", "sm")} {
            display: none;
        }
    `,
};
slideshowStyles.iconProps = {
    size: 16,
};
slideshowStyles.dotButton = {
    css: css`
        flex: 1 1 0;
        min-height: 6px;
        border: 0;
        border-radius: 0;
        background: ${getColor("common.ui5")};
        &:hover,
        &:active {
            background: ${getColor("common.border")};
        }
        &:focus {
            outline: none;
        }
    `,
};
slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        position: absolute;
        width: 100%;
        gap: 6px;
        bottom: 0;
    `,
};

slideshowStyles.pauseIcon = {
    size: 20,
    color: "common.ui1",
    css: css`
        position: absolute;
        left: 13px;
        bottom: 19px;
        &:hover {
            svg {
                color: ${color("common.ui9")};
            }
        }
    `,
};
